<template>
    <v-container>
        <div v-if="!reports_statusevents.reportEvents">
            <h3>Loading events...</h3>
        </div>
        <div v-else id="eventcontainer">
            <h1 class="mb-1" v-html="reports_statusevents.reportConfig.eventtitle || 'Past Events'"></h1>
            <div id='eventsbetween'>
                {{betweenDates}}.
            </div>
            <v-card v-if="!eventCount">
                 <v-card-text>
                     <v-card class="pa-2 " flat>
                        {{ reports_statusevents.reportConfig.noeventstext || "No Events Reported" }}
                     </v-card>
                 </v-card-text>
            </v-card>
            <div v-else class="mt-4">
                <div v-for="(record, day) in reports_statusevents.reportEvents" v-bind:key="record.key || day" >
                    <ReportEventsDay :record="record" :day="day" />
                </div>
            </div>
            <v-row  v-if="showmore">
                <v-btn class="ma-2" outlined @click="getNextPage()">Load More</v-btn>

            </v-row>
        </div>
    </v-container>
</template>

<script>
import { mapState } from 'vuex';
import {
    format as date_format,
    parse as date_parse ,
    subDays as date_subDays,
    subWeeks as date_subWeeks,
    subMonths as date_subMonths
} from "date-fns";
import _size from "lodash/size";
import _find from "lodash/find";
import { filterId } from "../lib/filter";
import ReportEventsDay from "./Reports_Statusevents_Events_Day";

export default {
    name: "Reports_Statusevents_Events",
    props: {
        runpolling: {
            type: Boolean,
            default: false
        },
        reportid: {
            type: String
        },
        showConfig: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            // reportid: (window.reportid && filterId(window.reportid)) || this.$route.params.reportid,
            checkcache: {},
            // showmore: true,
            page: 0,
            startdate: false,
            enddate: false,
            showdiag: false
        }
    },
    components: { ReportEventsDay },
    computed: {
        ...mapState(['reports_statusevents', 'checks', 'now']),
        eventCount: function () {
            return _size(this.reports_statusevents.reportEvents)
        },
        betweenDates: function () {
            if(this.reports_statusevents.eventParams && this.reports_statusevents.eventParams.start && this.reports_statusevents.eventParams.end ){
                let offset = this.reports_statusevents.eventParams.offset || 0;
                // let start = date_format(date_parse(this.reports_statusevents.eventParams.start - offset), 'YYYY-MM-DD');
                // let end = date_format(date_parse(this.reports_statusevents.eventParams.end - offset), 'YYYY-MM-DD');
                let start = date_format(date_parse(this.startdate - offset), 'YYYY-MM-DD');
                let end = date_format(date_parse(this.enddate - offset), 'YYYY-MM-DD');
                return " Between " + start + " and " + end;
            } else {
                return ""
            }
        },
        showmore: function() {
            const eventslimitspans = {
                "One week": () => date_format(date_subWeeks(new Date, 1),"YYYY-MM-DD"),
                "Two weeks": () => date_format(date_subWeeks(new Date, 2),"YYYY-MM-DD"),
                "One month": () => date_format(date_subMonths(new Date, 1),"YYYY-MM-DD"),
                "Three months": () => date_format(date_subMonths(new Date, 3) ,"YYYY-MM-DD")
            };
            let notbefore = this.reports_statusevents.reportConfig.eventsnotbefore && eventslimitspans[this.reports_statusevents.reportConfig.eventsnotbefore] && eventslimitspans[this.reports_statusevents.reportConfig.eventsnotbefore]();
            let startdate = date_format(date_parse(this.startdate),"YYYY-MM-DD");
            // console.log('showmore\n', notbefore, '\n', startdate, '\n', (notbefore < startdate ))
            return (this.reports_statusevents.eventParams.more || !notbefore || notbefore < startdate );
        }
    },
    methods: {
        getCheckField: function ( jobid, field ) {
            // console.log('job in filterCheckTitle', this.reports_statusevents.reportChecks );
            let job;
            field = field || 'label';
            if(this.checkcache[jobid]){
                return this.checkcache[jobid][field]
            } else {
                job = _find(this.reports_statusevents.reportChecks, function(record){ return record && record._id === jobid });
                if(job){
                    this.checkcache[jobid] = {
                        label: (job.report && job.report.label) || job.label || jobid,
                        showlink: this.reports_statusevents.reportConfig.showlinks && job.public,
                        uuid: job.uuid,
                        _id: jobid
                    };
                } else {
                    this.checkcache[jobid] = {
                        label: jobid,
                        showlink: false
                    };
                }
                return this.checkcache[jobid][field];
            }
        },
        startPolling: function (options) {
            // console.log('events.startPolling', options);
            clearTimeout(this.$options.polling);
            options = options || {poll: 1};
            this.getEvents(options)
                .then( () => {
                    // console.log('events set?', this.reports_statusevents.reportEvents);
                    this.$options.polling = setTimeout(
                        this.startPolling,
                        60000
                    )
                })
        },
        stopPolling: function () {
            clearTimeout(this.$options.polling);
        },
        getEvents: function(options) {
            options = options || {};
            var ypos = window.pageYOffset;
            let params = {};
            const enddate = new Date().toISOString().slice(0,10); 
            let startdate = date_format(date_parse(this.startdate),"YYYY-MM-DD"); 
            if(options.poll){
                params = {
                    reportid: this.reportid,
                    start: startdate + "T00:00:00",
                    end: enddate + "T23:59:59",
                    eventsinterval: 'days'
                }
            } else if(options.end){
                params = options;
                params.reportid = this.reportid;
                params.offset = 0;
            } else {
                params = {
                    reportid: this.reportid,
                    eventpage: this.page
                };
            }
            // console.log('statusevents sending getEvents', params);
            return this.$store.dispatch("reports_statusevents/listEvents", params)
                .then( () => {
                    // console.log('events from store', this.reports_statusevents.reportEvents)
                    // console.log('eventParams', this.reports_statusevents.eventParams);

// end:        1597289318768
// firststart: 1597254423787
// laststart:  1597083542100
// start:      1594610918767
// interval: "months"
// length: 50
// limit: 50
// more: true
// offset: 25200000

                    if(this.reports_statusevents.eventParams.more && this.reports_statusevents.eventParams.laststart){
                        // console.log('laststart is startdate', this.reports_statusevents.eventParams.laststart)
                        this.startdate = this.reports_statusevents.eventParams.laststart;
                    } else if(!this.startdate || this.reports_statusevents.eventParams.start < this.startdate){
                        this.startdate = this.reports_statusevents.eventParams.start;
                    }
                    if(!this.enddate || this.reports_statusevents.eventParams.end > this.enddate){
                        this.enddate = this.reports_statusevents.eventParams.end;
                    }
                    this.$nextTick(() => {
                        window.scrollTo(0, ypos)
                    });
                })
        },
        getNextPage: function() {

            if(this.reports_statusevents.eventParams.more){
                this.startPolling({end: this.reports_statusevents.eventParams.laststart})
            } else if(!this.reports_statusevents.eventParams.more){
                this.page++;
                this.startPolling({page: true});
            }
        }

    },
    created () {
        // this.startPolling({initial: true});
    },
    watch: {
        runpolling: {
            immediate: true,
            handler: function(newVal, oldVal) {
                // console.log("Checking runpolling in events", newVal);
                if(newVal){
                    this.startPolling({starting:true});
                } else {
                    this.stopPolling();
                }
            }
        }
    },
    beforeDestroy () {
        this.stopPolling();
    }
}
</script>

<style scoped>
    .joblabel {
        font-weight: bold;
        font-size: 1.1em;
        color: #333;
    }
    .eventday h3 {
        padding-bottom: 12px;
        border-bottom: 1px solid #ccc;
    }
    .eventday {
        margin-bottom: 12px;
    }
    .eventsbetween {
        margin-bottom: 16px;
    }
</style>